'use client'

import { toast } from '@/hooks/use-toast'
import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

export function CookieToast() {
  const [cookies, setCookie] = useCookies(['userCookieConsent'])

  useEffect(() => {
    if (!cookies.userCookieConsent) {
      const timeout = setTimeout(() => {
        const { dismiss } = toast({
          title: 'Usamos cookies 🍪',
          description:
            'Usamos cookies de terceiros para melhorar sua experiência. Ao utilizar este site, você concorda com o uso.',
          action: (
            <button
              onClick={() => {
                setCookie('userCookieConsent', true, {
                  path: '/',
                  maxAge: 3600 * 24 * 365,
                })
                dismiss()
              }}
              className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
            >
              Aceitar
            </button>
          ),
          duration: Infinity, // Fica aberto até aceitar
        })
      }, 5000) // 5000 ms = 5 segundos

      return () => clearTimeout(timeout) // limpeza do timeout se desmontar o componente
    }
  }, [cookies, setCookie])

  return null // Componente invisível
}
